import React from "react";
import { useState } from "react";

const Checkbox = ({
  rowId,
  initValue,
  accessToken,
  table,
  colId,
  editable,
  editId,
  onCellChange
}) => {
  const [checked, setChecked] = useState(initValue || false);

  //handling next thing changes
  const submitChanges = async (e) => {
    const newValue = !checked;
    try {
      if (!editable) return;
      setChecked(newValue);

      // Trigger cell update acknowledgment
      if (onCellChange) {
        onCellChange(rowId, colId, newValue);
      }
    } catch (error) { }
  };

  return (
    <div className="smart-table-cell flex justify-center">
      <input
        type="checkbox"
        checked={checked}
        name={`checkbox_${colId}`}
        id={`checkbox_${colId}`}
        value={checked}
        disabled={!editable}
        onChange={submitChanges}
        className=".checkbox-lg h-6 w-6 rounded border-gray-300 text-green-500 focus:ring-green-500"
      />
    </div>
  );
};

export default Checkbox;
